import { Component, Input, OnInit, OnDestroy, ElementRef, ViewChild, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as echarts from 'echarts';

@Component({
  selector: 'app-line-chart',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.css']
})
export class LineChartComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {
  @Input() className: string = 'chart';
  @Input() width: string = '100%';
  @Input() height: string = '350px';
  @Input() autoResize: boolean = true;
  @Input() chartData: any = {
    expectedData: [120, 132, 101, 134, 90, 230, 210],
    actualData: [220, 182, 191, 234, 290, 330, 310]
  };

  @ViewChild('chartContainer', { static: true }) chartContainer!: ElementRef;

  private chart: echarts.ECharts | null = null;

  ngOnInit(): void {
    // Component initialization
  }

  ngAfterViewInit(): void {
    this.initChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['chartData'] && this.chart) {
      this.setOptions(this.chartData);
    }
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  }

  private initChart(): void {
    if (!this.chartContainer?.nativeElement) return;

    this.chart = echarts.init(this.chartContainer.nativeElement);
    this.setOptions(this.chartData);

    // Handle window resize
    if (this.autoResize) {
      window.addEventListener('resize', () => {
        if (this.chart) {
          this.chart.resize();
        }
      });
    }
  }

  private setOptions(data: any = {}): void {
    if (!this.chart) return;

    const { expectedData, actualData } = data;

    this.chart.setOption({
      xAxis: {
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        boundaryGap: false,
        axisTick: {
          show: false
        }
      },
      grid: {
        left: 10,
        right: 10,
        bottom: 20,
        top: 30,
        containLabel: true
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'cross'
        },
        padding: [5, 10]
      },
      yAxis: {
        axisTick: {
          show: false
        }
      },
      legend: {
        data: ['expected', 'actual']
      },
      series: [{
        name: 'expected',
        itemStyle: {
          normal: {
            color: '#FF005A',
            lineStyle: {
              color: '#FF005A',
              width: 2
            }
          }
        },
        smooth: true,
        type: 'line',
        data: expectedData || [120, 132, 101, 134, 90, 230, 210],
        animationDuration: 2800,
        animationEasing: 'cubicInOut'
      },
      {
        name: 'actual',
        smooth: true,
        type: 'line',
        itemStyle: {
          normal: {
            color: '#3888fa',
            lineStyle: {
              color: '#3888fa',
              width: 2
            }
          }
        },
        data: actualData || [220, 182, 191, 234, 290, 330, 310],
        animationDuration: 2800,
        animationEasing: 'quadraticOut'
      }]
    });
  }

  public updateChartData(data: any): void {
    this.chartData = data;
    if (this.chart) {
      this.setOptions(data);
    }
  }
}
